module.exports = __webpack_public_path__ + "static/media/address-icon.072cbf7e.svg";